import { render } from "./PasswortVorraussetzung.vue?vue&type=template&id=c4a9583e"
import script from "./PasswortVorraussetzung.vue?vue&type=script&lang=js"
export * from "./PasswortVorraussetzung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__